<div class="article-body">
  @for (section of content().sections; track section.id; let i = $index) {
    <section
      [id]="section.id"
      class="article-body__section"
      aos="fade-up"
      [aosDelay]="i * 50"
    >
      <h2 class="article-body__heading">{{ section.heading }}</h2>

      <!-- B124: HTML ya saneado por la API (perfil blog_section); Angular lo
           vuelve a sanear al pintarlo. Nunca bypassSecurityTrust*. -->
      <div class="article-body__html" [innerHTML]="section.bodyHtml"></div>

      @if (section.videoUrl; as videoUrl) {
        <div class="article-body__video">
          <app-game-video-embed [videoUrl]="videoUrl" [caption]="section.videoCaption" />
        </div>
      }

      @if (section.imageUrl) {
        <figure class="article-body__figure">
          <img
            class="article-body__image"
            [src]="section.imageUrl"
            [alt]="section.imageAlt || section.heading"
            loading="lazy"
          />
          @if (section.imageCaption) {
            <figcaption class="article-body__caption">{{ section.imageCaption }}</figcaption>
          }
        </figure>
      }

      @if (section.quote) {
        <blockquote
          class="article-body__quote"
          [style.--quote-accent]="accentColor()"
        >
          {{ section.quote }}
        </blockquote>
      }

      @if (section.inlineProduct) {
        <app-article-inline-product [product]="section.inlineProduct" />
      }
    </section>
  }
</div>
